import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=27033615&"
import script from "./MyProfile.ts?vue&type=script&lang=ts&"
export * from "./MyProfile.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports